<template>
  <div class="status-badges" v-if="entries.length">
    <span
      class="tags"
      v-for="[code, count] in entries"
      v-bind:key="code || 'empty'"
      :class="{ 'tag-empty': !code }"
      :style="code ? { backgroundColor: statusColor(code) } : {}"
    >
      {{ code || "Vazio" }}: {{ count }}
    </span>
  </div>
  <span v-else>—</span>
</template>

<script>
/**
 * TeacherEvaluationStatusCell
 *
 * Célula de tabela que resume, por código, a quantidade de avaliações
 * de cada status no mês atual (ex.: `{ A: 342, EE: 453 }`) como badges
 * coloridos — mesma paleta por código usada em Statistics.vue e nos
 * componentes de RDA (StudentRDAComponent/RDAComponentCompetence).
 * Específico do domínio de professores.
 *
 * `status` pode vir `null`/vazio (professor sem avaliações no mês) —
 * nesse caso exibe "—" em vez de quebrar.
 */
export default {
  name: "TeacherEvaluationStatusCell",

  props: {
    /** `teacher.lastEvaluationsDates.currentMonth.status` — pode ser null/undefined. */
    status: {
      type: Object,
      default: null,
    },
  },

  computed: {
    entries() {
      return Object.entries(this.status || {});
    },
  },

  methods: {
    statusColor(code) {
      switch (code) {
        case "EE":
          return "#b23066";
        case "AN":
          return "#ffbb00";
        case "*":
          return "#8e8989";
        case "#":
          return "#a9a9a9";
        default:
          return "#68c5b7";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.status-badges {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
  max-height: 120px;
  overflow-y: auto;
}

.tags {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 8px;
  border-radius: 4px;
  color: $white;
  font-weight: $bold;
  font-size: 11px;
  text-align: center;
  white-space: nowrap;

  &.tag-empty {
    background-color: $grey6;
    color: $grey4;
    font-weight: $regular;
    font-style: italic;
  }
}
</style>
